.content {
  display: flex;
  flex: 1;
  min-height: 0;
  position: relative;
}

.sidebar {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 232px;
  overflow: hidden;
  background: var(--card-bg);
  border-right: 1px solid var(--border);
}

.head {
  flex-shrink: 0;
  padding: 22px 16px 12px;
}

.title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.total {
  font-size: 12.5px;
  font-weight: 400;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.searchInput {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  font-size: 13px;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.searchInput:focus {
  outline: none;
  border-color: var(--blue);
}

.list {
  flex: 1;
  padding: 0 8px 16px;
  overflow-y: auto;
}

.none {
  padding: 12px 8px;
  font-size: 13px;
  color: var(--text2);
}

.group + .group {
  margin-top: 6px;
}

.groupName {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 8px 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  background: var(--card-bg);
}

.item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 5px 8px;
  width: 100%;
  padding: 7px 8px 8px;
  font-size: 13.5px;
  color: var(--text);
  text-align: left;
  background: none;
  border: none;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.item:hover {
  background: var(--table-hover);
}

.itemActive,
.itemActive:hover {
  background: var(--blue-lt);
  box-shadow: inset 3px 0 0 var(--blue);
}

.itemActive .itemName {
  font-weight: 600;
  color: var(--blue);
}

:global(html.dark) .itemActive .itemName {
  color: var(--navy-accent);
}

.itemName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count {
  font-size: 12px;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

/* Та же полоска, что на плитках дашборда */
.strip {
  grid-column: 1 / -1;
  display: flex;
  gap: 1px;
  height: 3px;
  overflow: hidden;
  border-radius: 1px;
}

.segClean {
  background: var(--led-clean);
}
.segChecked {
  background: var(--led-checked);
}
.segOpen {
  background: var(--led-open);
}

.panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

/* ── Телефон ──
   Колонки нет. Объект не выбран — плитки на весь экран (.mobileHome);
   выбран — содержимое объекта, а другой объект выбирается из панели
   снизу (.sheet). На компьютере и планшете этих частей нет. */
.mobileHome,
.sheetLayer {
  display: none;
}

@media (max-width: 699px) {
  .sidebar {
    display: none;
  }

  .contentHome .panel {
    display: none;
  }

  .mobileHome {
    display: flex;
    flex: 1;
    min-width: 0;
    background: var(--bg);
  }

  .sheetLayer {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 60;
  }

  .scrim {
    position: absolute;
    inset: 0;
    background: var(--scrim);
    border: none;
    animation: fadeIn 0.2s ease-out;
  }

  .sheet {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    height: 86vh;
    height: 86dvh;
    overflow: hidden;
    background: var(--bg);
    border-radius: 18px 18px 0 0;
    box-shadow: 0 -12px 40px var(--shadow);
    animation: slideUp 0.26s cubic-bezier(0.2, 0.8, 0.2, 1);
  }

  .sheet:focus {
    outline: none;
  }

  :global(html.dark) .sheet {
    box-shadow: 0 0 0 1px var(--border);
  }

  .grabber {
    flex-shrink: 0;
    width: 40px;
    height: 4px;
    margin: 8px auto 0;
    background: var(--border);
    border-radius: 2px;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sheet,
  .scrim {
    animation: none;
  }
}
